var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3d3df69a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DownloadInternalStudySessionDocs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/lecturer/DownloadInternalStudySessionDocs.vue
// module id = 285
// module chunks = 1